export default __webpack_public_path__ + "static/media/gradient_mobile.f6fc89c0.png";